// extracted by mini-css-extract-plugin
module.exports = {"root":"OrderModeButton_root__2HWew","selectedButton":"OrderModeButton_selectedButton__3IKcu"};